import * as moment from 'moment-timezone';

export const formatTimeFromPresent = (dateTime) => {
  let time = moment.parseZone(dateTime);
  let formattedTime = time.format("h:mm A");
  if(time.format("M/D/YYYY") != moment().format("M/D/YYYY")) {
    formattedTime = time.format("M/D @ h:mm A");
  }
  return formattedTime;
}

export const getFutureThirtyDays = () => {
  return [...new Array(30)].map((i, idx) => moment().startOf("day").add(idx, "days"));
}

export const getTimeAgo = (time) => {
  let timeAgo = setRelativeTimeForMoment().parseZone(time);
  return timeAgo.fromNow(true);
};

export const setRelativeTimeForMoment = () => {
  moment.updateLocale('en', {
    relativeTime : {
        future: "in %s",
        past:   "%s ago",
        s  : 'Now',
        ss : '%ds',
        m:  "1m",
        mm: "%dm",
        h:  "1h",
        hh: "%dh",
        d:  "1d",
        dd: "%dd",
        w:  "1w",
        ww: "%dw",
        M:  "1mo",
        MM: "%dmo",
        y:  "1y",
        yy: "%dy"
    }
  });
  return moment;
}
